import { anchorLinkTarget } from "page/wiki/menu-helper";
import css from "page/wiki/rewards/guild-rewards.scss";
import { MENU_LINKS_CONFIG } from "page/wiki/rewards/rewards";
import React from "react";

export default function GuildRewards() {
  if (css) {
  }
  return (
    <div>
      {anchorLinkTarget(MENU_LINKS_CONFIG["Guild Rewards"])}
      <div>
        <h4>Basics</h4>
        <div>
          The guild pass is basically a community driven season, where you and you're guild
          contribute every cycle to increase the glory and gain tiers.
          <br />
          <br />
          The guild pass lasts 30 days and it's made by 3 days cycle (10 cycles total). Every 3 days
          every guild member can contribuite (you need to enable the conquest mode in the guild
          screen), by winning games to increase the total guild glory. Each member can have up to 6
          victories in conquest mode each cycle, and they can lose up to 3 times. Once you win 6
          times or lose 3, you cannot contribute anymore until the next cycle.
          <br />
          <br />
          Every guild has a set of "Conquest Cards" available (the number increase while the guild
          progress in the guild pass), and those cards provides bonus glory to the conquest battles
          and as bonus, those cards are available for every guild member (even if they don't have
          those cards in their collection). The bonus glory from the conquest cards{" "}
          <u>
            <b>DOES NOT</b>
          </u>{" "}
          apply to wild cards (so you get the bonus only for the first copy of the card, not the
          second one).
          <br />
          <div className="bb_h1">
            <b>How to contribute</b>
          </div>
          <br />
          In order to contribute in the guild pass, you need to use a deck with a high amount of
          glory, and possibly to use the conquest cards. Each conquest card in your deck provides
          extra 400 glory for the guild pass.
          <br />
          <b>
            <u>NOTE:</u>
          </b>{" "}
          every guild has a different set of conquest cards.
          <br />
          <br />
          To contribute, just enable the conquest mode from the guild screen, then you can play in
          any mode (excluding draft, mayhem and expeditions) and your victories will count towards
          the guild pass. If your conquest mode is active, the guild emblem will be visible near the
          usual "Battle" button to start a game.
          <br />
          <br />
          <br />
          <br />
          Your total contribution for the cycle is visible in the guild screen, and the guild roster
          shows your total contribution for the season.
          <br />
          <br />
          All the glory earned by the <b>TOP 20 GUILD MEMBERS</b> will be added to the guild pass at
          the end of every cycle, all the rest won't count at all.
          <br />
          <br />
          <u>
            <b>NOTE:</b>
          </u>{" "}
          remember that once you have lost 3 times there is no way to try again (is not like drafts
          or mayhem where you can buy a new ticket and try again), so if you are having a lose
          streak, remember to pause the conquest and to resume at better times.
          <br />
          <br />
          <u>
            <b>NOTE 2:</b>
          </u>{" "}
          if you start the conquest in one guild, and then join another guild, you won't be able to
          give any contribution until the next cycle.
          <br />
          <br />
          <u>
            <b>NOTE 3:</b>
          </u>{" "}
          don't try to complete your conquest at the last minute! In fact if the cycle changes while
          you are playing, the points will be count for the next cycle and the previous contribution
          will be lost.
          <br />
          <br />
          <u>
            <b>NOTE 4:</b>
          </u>{" "}
          when you are in conquest, you will never be put against your own guild members.
          <br />
          <br />
          <div className="bb_h1">
            <b>Rewards</b>
          </div>
          <br />
          The guild pass provides rewards for all the guild members, in addition to extra conquest
          cards, each member also earn skins, avatars, a frame border for your avatar and cards pack
          (like 5 or more copies of a single card) of an increasing rarity, up to 3 legendaries at
          tier 20.
          <br />
          <br />
          <u>
            <b>NOTE:</b>
          </u>{" "}
          New guild members won't be able to collect previous cycles rewards, only the rewards
          obtained from the cycle he became part of the guild onwards.
          <br />
          <br />
          In addition to all that,{" "}
          <b>
            <u>the number one guild</u>
          </b>{" "}
          also receive additional 5 legendaries for all its members at the end of the season.
          <br />
          <br />
          Is pointless to say that all this rewards are a great incentive for anyone to be part of a
          guild, and to work together in order to reach the top tier before the end of the season.
          <br />
          <br />
        </div>
      </div>
      Here is the list of rewards as an example from past Season:
      <fieldset>
        <legend>Guild Rewards</legend>
        <ol>
          <li>
            {" "}
            5 x Conquest Card slot
            <br />
          </li>
          <li>
            {" "}
            1 x Conquest Card slot
            <br />
          </li>
          <li>
            {" "}
            10 x Common Card
            <br />
          </li>
          <li>
            {" "}
            1 x Conquest Card slot
            <br />
          </li>
          <li>
            {" "}
            5 x Rare Card
            <br />
          </li>
          <li>
            {" "}
            500k Account XP
            <br />
          </li>
          <li>
            {" "}
            1 x Conquest Card slot
            <br />
          </li>
          <li>
            {" "}
            15 x Common Card
            <br />
          </li>
          <li>
            {" "}
            +50 Season bonus Glory
            <br />
          </li>
          <li>
            {" "}
            Avatar
            <br />
          </li>
          <li>
            {" "}
            750k Account XP
            <br />
          </li>
          <li>
            {" "}
            1 x Conquest Card slot
            <br />
          </li>
          <li>
            {" "}
            7 x Supreme Card
            <br />
          </li>
          <li>
            {" "}
            1 x Conquest Card slot
            <br />
          </li>
          <li>
            {" "}
            3 x Supreme Cards
            <br />
          </li>
          <li>
            {" "}
            750k Account XP
            <br />
          </li>
          <li>
            {" "}
            10 x Rare Card
            <br />
          </li>
          <li>
            {" "}
            20 x Common Card
            <br />
          </li>
          <li>
            {" "}
            Guild Frame
            <br />
          </li>
          <li> 1 x Legendary Card</li>
        </ol>
      </fieldset>
      <br />
      <fieldset>
        <legend>Rewards > 20</legend>

        <ol>
          <li>
            {" "}
            3 x Common Card
            <br />
          </li>
          <li>
            {" "}
            500 x Gold
            <br />
          </li>
          <li>
            {" "}
            3 x Common Card
            <br />
          </li>
          <li>
            {" "}
            250k Account XP
            <br />
          </li>
          <li> 1 x Power Token</li>
        </ol>
      </fieldset>
      The total glory you'll receive after each victory is:
      <fieldset>
        <legend>Ranks Multiplier formula</legend>
        <p>
          <b>
            ( &lt;Conquest Card Glory&gt; + &lt;Your Deck Glory&gt; + &lt;Season Bonus Glory&gt; ) x
            &lt;Rank Multiplier&gt;{" "}
          </b>
        </p>
        <p>The multiplier for the formula above is ( xx% / 100 ) + 1.</p>
        <div>
          <img
            src="/img/basics/guild_formula.png"
            alt="Guild formula"
            style={{ maxWidth: "400px", width: "100%" }}
          />
        </div>
      </fieldset>
      <fieldset>
        <legend>Glory Rewards</legend>
        Here is the amount of glory required for each tier:
        <div className="bb_table">
          <div className="bb_table_tr">
            <div className="bb_table_th">
              <b>Tier</b>
            </div>{" "}
            <div className="bb_table_th">
              <b>Mini Season Glory</b>
            </div>{" "}
            <div className="bb_table_th">
              <b>Normal Season Glory</b>
            </div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">1</div> <div className="bb_table_td">---</div>{" "}
            <div className="bb_table_td">---</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">2</div> <div className="bb_table_td">145k</div>{" "}
            <div className="bb_table_td">150k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">3</div> <div className="bb_table_td">155k</div>{" "}
            <div className="bb_table_td">160k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">4</div> <div className="bb_table_td">165k</div>{" "}
            <div className="bb_table_td">180k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">5</div> <div className="bb_table_td">175k</div>{" "}
            <div className="bb_table_td">190k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">6</div> <div className="bb_table_td">185k</div>{" "}
            <div className="bb_table_td">200k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">7</div> <div className="bb_table_td">195k</div>{" "}
            <div className="bb_table_td">210k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">8</div> <div className="bb_table_td">205k</div>{" "}
            <div className="bb_table_td">220k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">9</div> <div className="bb_table_td">215k</div>{" "}
            <div className="bb_table_td">235k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">10</div> <div className="bb_table_td">230k</div>{" "}
            <div className="bb_table_td">245k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">11</div> <div className="bb_table_td">240k</div>{" "}
            <div className="bb_table_td">260k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">12</div> <div className="bb_table_td">255k</div>{" "}
            <div className="bb_table_td">275k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">13</div> <div className="bb_table_td">265k</div>{" "}
            <div className="bb_table_td">290k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">14</div> <div className="bb_table_td">280k</div>{" "}
            <div className="bb_table_td">305k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">15</div> <div className="bb_table_td">300k</div>{" "}
            <div className="bb_table_td">325k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">16</div> <div className="bb_table_td">315k</div>{" "}
            <div className="bb_table_td">340k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">17</div> <div className="bb_table_td">330k</div>{" "}
            <div className="bb_table_td">360k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">18</div> <div className="bb_table_td">350k</div>{" "}
            <div className="bb_table_td">380k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">19</div> <div className="bb_table_td">370k</div>{" "}
            <div className="bb_table_td">400k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">20</div> <div className="bb_table_td">390k</div>{" "}
            <div className="bb_table_td">420k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">21</div> <div className="bb_table_td">410k</div>{" "}
            <div className="bb_table_td">445k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">22</div> <div className="bb_table_td">435k</div>{" "}
            <div className="bb_table_td">470k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">23</div> <div className="bb_table_td">455k</div>{" "}
            <div className="bb_table_td">495k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">24</div> <div className="bb_table_td">480k</div>{" "}
            <div className="bb_table_td">520k</div>{" "}
          </div>{" "}
          <div className="bb_table_tr">
            {" "}
            <div className="bb_table_td">25+</div> <div className="bb_table_td">605k</div>{" "}
            <div className="bb_table_td">655k</div>{" "}
          </div>
        </div>{" "}
      </fieldset>
    </div>
  );
}
